<template>
  <div class="main">
    <product-banner class-name="productBg" :title="banner.title" :desc="banner.desc"></product-banner>

    <ul class="about-nav">
      <li @mouseover="navOver(0)" :class="{active:navNum==0}">公司介绍</li>
      <li @mouseover="navOver(1)" :class="{active:navNum==1}">超强天团</li>
    </ul>
    <div class="about" v-show="navNum == 0">
      <div class="about-container w">
        <div class="m-title">
          <h2>关于我们</h2>
        </div>
        <div class="about-desc">
          <p>深圳厚科信息技术有限公司成立于 2008 年，是一家专注于医药行业管理系统解决方案的提供商。</p>
          <p>公司依托专业的技术团队、完善的服务体系，为超过 3000 家药店提供医药零售管理系统解决方案，助力药房提升专业服务能力与会员粘度，建立差异化的竞争优势。</p>
          <p>公司以“人人更健康，家庭更幸福 ”为使命，以“厚德载物，科技创新 ” 为经营理念，致力打造成客户最信赖的服务提供商，共创大健康时代。</p>
        </div>
      </div>

      <div class="culture"></div>

      <div class="advantage">
        <div class="advantage-container w">
          <div class="m-title">
            <h2>我们的优势</h2>
          </div>
          <ul class="advantage-list">
            <li v-for="item in advantageList" :key="item.id">
              <div class="advantage-svg">
                <svg-icon :icon-class="item.svg" class-name="svg"></svg-icon>
              </div>
              <div class="advantage-inner">
                <h3>{{item.name}}</h3>
                <p>{{item.content}}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="team" v-show="navNum == 1">
      <div class="team-container w">
        <div class="m-title">
          <h2>超强天团</h2>
          <p>顶尖顾问团队，专业技术研发团队，资深服务团队</p>
        </div>
        <ul class="team-list">
          <li v-for="item in teamList" :key="item.id">
            <div class="team-pic">
              <img :src="item.path" alt />
            </div>
            <div class="team-info">
              <div class="team-name">{{item.name}}</div>
              <div class="team-post">{{item.post}}</div>
              <div class="team-desc" :title="item.desc">{{item.desc}}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <to-try class-name="c-apply" type="2"></to-try>
  </div>
</template>
<script>
export default {
  data() {
    return {
      banner: {
        title: "厚德载物 科技创新",
        desc: "成为中国医药行业最信赖的管理系统解决方案提供商"
      },
      navNum: 0,
      advantageList: [
        {
          svg: "about_advantage1",
          name: "功能完善",
          content:
            "本着用户至上原则，不断提高系统的实用性、易用性，完善性，为用户创造价值体验。"
        },
        {
          svg: "about_advantage2",
          name: "易学易用",
          content: "半天培训，两天上岗，三天熟练"
        },
        {
          svg: "about_advantage3",
          name: "快速迭代",
          content:
            "敏锐洞悉瞬息万变的医药零售市场，快速迭代系统新功能，为用户打造应变时代的紧固城墙。"
        },
        {
          svg: "about_advantage4",
          name: "顾客信赖",
          content:
            "十几年的砥砺深耕，用卓越的品质与专业的服务回报每一个用户，造就众多用户信赖选择。"
        },
        {
          svg: "about_advantage5",
          name: "大数据分析",
          content:
            "系统采用互联网技术、信息技术、大数据分析技术，整合庞大数据资源，抓取分析价值数据，为医药企业轻松诊断运营问题，提供行业市场变化趋势，助力企业立足于风云变幻的医药零售行业。"
        }
      ],
      teamList: [
        {
          path: require("../../assets/imgs/team-pic1.png"),
          name: "张建明",
          post: "创始人CEO  数据分析与慢病管理专家",
          desc:
            "19年医药流通与零售连锁行业信息化管理经验，在连锁管理系统规划，专业药房信息管理系统，慢病管理，医药连锁信息化数据管理以及营运分析系统的建设方面，具有丰富经验。"
        },
        {
          path: require("../../assets/imgs/team-pic2.png"),
          name: "郭雅玲",
          post: "吉林大学MBA",
          desc:
            "18年大型医药连锁工作经验，具有丰富的医药零售业的品牌规划管理、自有品牌推广、市场营销、会员管理、电子商务平台规划及运营经验，海王星辰会员制度的创立人，会员日营销的发起人。"
        },
        {
          path: require("../../assets/imgs/team-pic3.png"),
          name: "张国芳",
          post: "高级顾问",
          desc:
            "CAMORE（康顾多）医药连锁总经理；前美信医药国际连锁总经理；中国台湾博登连锁药局创始人。曾通过引入美国连锁加盟模式，在十年内将其创立的中国台湾博登连锁药局发展成为台湾排名第一的连锁药房。"
        },
        {
          path: require("../../assets/imgs/team-pic4.png"),
          name: "姜明",
          post: "",
          desc: "10年医药零售行业信息化管理经验"
        },
        {
          path: require("../../assets/imgs/team-pic5.png"),
          name: "林瑞彬",
          post: "",
          desc: "10年零售行业信息化数字管理系统研发经验"
        },
        {
          path: require("../../assets/imgs/team-pic6.png"),
          name: "朱荣森",
          post: "",
          desc: "美国项目管理协会PMI认证PMP（项目管理师）"
        }
      ]
    };
  },
  methods: {
    navOver(index) {
      this.navNum = index;
    }
  }
};
</script>
<style lang='scss' scoped>
$color: #213d81;
/deep/ .c-link {
  background: $color;
}
/deep/ .c-apply {
  color: $color;
  background: $color;
}

/deep/ .productBg {
  background-image: url("../../assets/imgs/banner_service.png");
}

.about-nav {
  @include clearfix;
  width: 912px;
  margin: 0 auto;
  li {
    width: 456px;
    height: 56px;
    line-height: 56px;
    text-align: center;
    float: left;
    font-size: 16px;
    font-weight: 400;
    color: #2f393f;
    border-bottom: 2px solid transparent;
    cursor: pointer;
  }
  .active {
    color: $color;
    border-color: $color;
  }
}
.about {
  width: 100%;

  .about-container {
    padding: 72px 0 40px;
    .about-desc {
      font-size: 18px;
      font-weight: 400;
      color: #2f393f;
      line-height: 25px;
      p {
        margin-bottom: 24px;
      }
    }
  }

  .culture {
    width: 100%;
    height: 780px;
    background: url("../../assets/imgs/about_culture_bg.png") no-repeat center
      center / 100% 780px;
    padding: 55px 0;
  }

  .advantage {
    padding: 72px 0;
    @include clearfix;
    .advantage-list {
      li:not(:last-child) {
        padding: 48px 0;
        float: left;
        width: 282px;
        min-height: 393px;
        border-radius: 2px;
      }
      li:not(:nth-child(4n)) {
        margin-right: 24px;
      }
      li:last-child {
        margin-top: 96px;
        width: 100%;
        @include clearfix;
        float: left;
        padding: 0 81px;
        .advantage-svg {
          float: left;
          margin-top: 14px;
        }
        .advantage-inner {
          float: left;
          margin-left: 50px;
          h3 {
            text-align: initial;
            margin-top: 0;
          }
          p {
            width: 614px;
          }
        }
      }
      .advantage-svg {
        width: 120px;
        height: 120px;
        background: #f2f2f2;
        margin: 0 auto;
        border-radius: 50%;
        font-size: 70px;
        text-align: center;
        line-height: 120px;
      }
      .advantage-inner {
        h3 {
          font-size: 22px;
          font-weight: 400;
          color: #000;
          line-height: 30px;
          margin-top: 32px;
          text-align: center;
        }
        p {
          font-size: 18px;
          font-weight: 400;
          color: #6c737d;
          line-height: 34px;
          margin-top: 16px;
        }
      }
    }
  }
}

.team {
  padding: 72px 0;
  .team-container {
    .team-list {
      @include clearfix;
      li {
        float: left;
      }
      li:first-child {
        width: 100%;
        margin-bottom: 124px;
        @include clearfix;
        .team-pic {
          width: 384px;
          height: 412px;
          background: #efecf0;
          float: left;
          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }

        .team-info {
          color: #2f393f;
          font-weight: 400;
          float: left;
          margin-left: 50px;
          .team-name {
            margin-top: 20px;
            font-size: 24px;
            line-height: 33px;
          }
          .team-post {
            height: 20px;
            font-size: 14px;
            line-height: 20px;
            margin-top: 8px;
            position: relative;
            &:after {
              content: "";
              position: absolute;
              left: 0;
              top: 52px;
              width: 30px;
              height: 2px;
              background: rgba(33, 61, 129, 1);
            }
          }
          .team-desc {
            font-size: 14px;
            line-height: 25px;
            margin-top: 64px;
            width: 614px;
          }
        }
      }
      li:not(:first-child) {
        width: 255px;
        height: 450px;
        margin-bottom: 98px;
        .team-pic {
          width: 100%;
          height: 275px;
          background: #efecf0;
          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
        .team-info {
          color: #2f393f;
          font-weight: 400;
          .team-name {
            font-size: 18px;
            line-height: 25px;
            margin-top: 20px;
          }
          .team-post {
            height: 20px;
            font-size: 14px;
            line-height: 20px;
            margin-top: 12px;
          }
          .team-desc {
            font-size: 14px;
            line-height: 25px;
            margin-top: 22px;
            @include ellipsis(5);
          }
        }
      }
      li:not(:nth-child(5n)) {
        margin-right: 60px;
      }
    }
  }
}
</style>
